import { useCartStore } from "../store/cartStore";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuthStore } from "../store/authStore";

export default function AddToCartButton({ product }) {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const addToCart = useCartStore((s) => s.addToCart);
  const updateQty = useCartStore((s) => s.updateQty);
  const cart = useCartStore((s) => s.cart);
  const [stockWarning, setStockWarning] = useState("");
  const [cartError, setCartError] = useState("");

  const qty =
    cart.find(
      (i) => i.productId === product._id || i.productId === product.productId,
    )?.quantity || 0;

  const handleAddToCart = async () => {
    setCartError("");

    // Check if user is logged in
    const userId = user?.id;

    if (!userId) {
      setCartError("Please login to proceed.");
      return true;
    }

    // Already in cart
    if (qty > 0) {
      navigate("/cart");
      return;
    }

    try {
      await addToCart(product._id, product);
    } catch (error) {
      console.error("Add to cart error:", error);
      setCartError("Please login to proceed.");
    }
  };

  return (
    <div className="flex items-center gap-4 mt-4">
      {/* Add to Cart Button (always visible) */}
      <button
        onClick={handleAddToCart}
        disabled={product.qty === 0}
        className={`px-4 py-2 rounded transition text-white
    ${
      product.qty === 0
        ? "bg-gray-500 cursor-not-allowed"
        : "bg-light_primary hover:bg-hover_light_primary"
    }`}
      >
        {product.qty === 0
          ? "Out of Stock"
          : qty > 0
            ? "View Cart"
            : "Add to Cart"}
      </button>
      {/* <button
        onClick={() => addToCart(product._id, product)}
        className={`px-4 py-2 rounded transition text-white 
        ${
          product.qty === 0
            ? "bg-gray-500 cursor-not-allowed"
            : "bg-light_primary hover:bg-hover_light_primary"
        }`}
      >
        {product.qty === 0 ? "Out of Stock" : "Add to Cart"}
      </button> */}
      {/* Qty Controls (show only if qty > 0) */}
      {qty > 0 && (
        <div className="flex items-center gap-3">
          <button
            onClick={() => updateQty(product._id, -1)}
            className="px-3 py-1 bg-gray-700 text-white rounded"
          >
            -
          </button>

          <span className="text-lg font-semibold text-black">{qty}</span>

          <button
            onClick={() => updateQty(product._id, +1)}
            disabled={qty >= product.qty}
            className={`px-3 py-1 rounded text-white transition ${
              qty >= product.qty
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gray-700 hover:bg-gray-800"
            }`}
          >
            +
          </button>

          {qty >= product.qty && (
            <p className="mt-2 text-sm text-red-600 font-medium">
              Maximum stock reached. Only {product.qty} item
              {product.qty > 1 ? "s" : ""} available.
            </p>
          )}
        </div>
      )}

      {/* Login Error */}
      {cartError && (
        <p className="text-sm text-red-600 font-medium">{cartError}</p>
      )}
    </div>
  );
}
